import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  textHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  sectionHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  companyDetailsContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    width: '100%',
  },
  inputWidth: {
    width: '50%',
  },
  datePicker: {
    "[role='group']": {
      height: `${theme.spacing(5)} !important`,
    },
    '& label': { top: 0 },
  },
  datePickerErrorOutline: {
    '& .MuiPickersOutlinedInput-root.Mui-error .MuiPickersOutlinedInput-notchedOutline':
      {
        border: `2px solid ${theme.palette.labraV2Errors.main}`,
      },
    '& .MuiPickersOutlinedInput-root.Mui-error:hover .MuiPickersOutlinedInput-notchedOutline':
      {
        border: `2px solid ${theme.palette.labraV2Errors.main}`,
      },
    '& .MuiPickersOutlinedInput-root.Mui-error.Mui-focused .MuiPickersOutlinedInput-notchedOutline':
      {
        border: `2px solid ${theme.palette.labraV2Errors.main}`,
      },
    '& .MuiFormHelperText-root.Mui-error': {
      paddingLeft: theme.spacing(2),
    },
    '& .MuiFormControl-root': {
      gap: '2px',
    },
  },
  recipientMargin: {
    marginTop: theme.spacing(1),
  },
}))
